import axios from 'axios';
import moment from 'moment';
import 'moment/locale/de'  // without this line it didn't work
moment.locale('de')
export default {
  data(){
    return {
      events: [],
      eventsLoading: true,
      filterLoaded: false,
      categories: [],
      pickedEventId: null,
      pickedCategoryId: null,
      currentEvent: {},
      filterKey: 0,
      filter: {
        term: '',
        startTime: null,
        category: [],
        weekday: [],
        district: [],
        eventType: [],
        audience: [],
        accessibility: []
      },
      filterBlank: {},
      filterValues: {
        category: [],
        weekday: [],
        district: [],
        eventType: [],
        audience: [],
        startTime: [],
        accessibility: []
      },
      filterValuesAvialable: {
        category: [],
        weekday: [],
        district: [],
        eventType: [],
        audience: [],
        startTime: [],
        accessibility: []
      },

      dayNames: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
      ]
    }
  },
  created(){
    this.pickedEventId    = new URLSearchParams(window.location.search).get('eventId')
    this.pickedCategoryId = new URLSearchParams(window.location.search).get('categoryId')
    if (this.pickedCategoryId){
      this.filter.category = [this.pickedCategoryId]
    }

    this.filterBlank = JSON.parse(JSON.stringify(this.filter))

    axios.get("/events/metadata")
    .then(r => {
      this.filterValues = r.data.filterValues
      this.filterValuesAvialable = r.data.filterValues
      this.filterLoaded = true
    })
  },
  computed: {
    datesListSection(){
      return document.getElementById('filterEnd')
    },
    pickedEvent(){
      if (this.pickedEventId){
        return this.events.find(e => { return e.id == +this.pickedEventId })
      }
    },
    anyFiltersSet(){
      var s = false
      Object.keys(this.filter).forEach(k => {
        if (JSON.stringify(this.filterBlank[k]) != JSON.stringify(this.filter[k])){
          s = true
        }
      })
      return s
    },
    filteredEvents(){
      return this.events.filter(e => {
        var s = true
        const singleValueFilters = ['category', 'eventType', 'district']
        // single value filters
        singleValueFilters.forEach(filterField => {
          if (this.filter[filterField].length){
            var si = this.filter[filterField].findIndex(f => {
              return f == e[filterField]
            })
            if (si == -1){
              s = false
            }
          }
        })

        // term filter
        var currentSearchTerms = this.filter.term.toLowerCase().split(" ")
        if (this.filter.term != '' && currentSearchTerms.length > 0){

          currentSearchTerms.forEach(st => {
            var ti = e.searchString.findIndex(es => {
              return es.includes(st)
            })
            if (ti == -1){
              s = false
            }
          })
        }


        // Time filter
        if (this.filter.startTime){
          if (this.getTimeInt(e.startTime) < this.filter.startTime){
            s = false
          }
        }

        ["audience", "accessibility", "weekday"].forEach(fname => {
          if (this.filter[fname].length){
            var check = false
            this.filter[fname].forEach(a => {
              if (e[fname].findIndex(x => { return x == a }) != -1 ){
                check = true
              }
            })
            if (check == false){
              s = false
            }
          }
        })


        return s
      })
    },
  },
  methods: {
    resetFilter(){
      this.filter = JSON.parse(JSON.stringify(this.filterBlank))
      this.$refs.filterBar.setCurrentFilter(this.filter)
    },
    setFilter(val){
      this.filter = JSON.parse(JSON.stringify(val))
      this.filterKey++
      this.scrollToDatesList()
      this.$refs.eventsList.setCurrentPage(1  )

    },
    scrollToDatesList(){
      if (this.datesListSection){
        this.datesListSection.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      }
    },
    getTimeInt(dateTimeStr) {
      const date = new Date(dateTimeStr)
      const hours = date.getHours()
      const minutes = date.getMinutes()
      return hours * 100 + minutes
    },
  }
}
